import React, { Fragment } from "react";
import { connect } from "react-redux";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { ViewModule, List } from "@material-ui/icons";
import FundsList from "./List";
import FundsTiles from "./Tiles";

class Funds extends React.Component {
  state = {
    view: "list"
  };

  listView = () => {
    this.setState({ view: "list" });
  };

  tileView = () => {
    this.setState({ view: "tile" });
  };

  render() {
    return (
      <Fragment>
        <div style={{width:"100%", overflow:"auto"}}>
          {this.state.view === "list" ? <FundsList /> : <FundsTiles />}
        </div>
        <Divider />
        <Button
          className="button_tableGridChanger _List"
          onClick={this.listView}
        >
          <List />
        </Button>
        <Button
          className="button_tableGridChanger _Block"
          onClick={this.tileView}
        >
          <ViewModule />
        </Button>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ fund }) => ({ fund });

export default connect(
  mapStateToProps  
)(Funds);
